import { __dev__, __preview__ } from "../../../../utils";
import { REGIONAL_INSTANCE_CONFIG } from "../regional-instance-constants";
import {
  RegionalInstanceEndpoints,
  RegionalInstanceId,
  URL_HTTPS,
} from "../regional-instance-types";

/**
 * Regional upstream origins for proxy rewrites and server-side callers without
 * a browser origin. Edge-safe — no React imports.
 *
 * Non-prod defaults to the hosted preview API; override with NEXT_PUBLIC_SERVER_URL
 * (e.g. http://localhost:8080 when running the backend locally).
 */
export function resolveRegionalInstanceEndpoints(
  regionalInstanceId: RegionalInstanceId
): RegionalInstanceEndpoints {
  if (__dev__ || __preview__) {
    const api =
      (process.env.NEXT_PUBLIC_SERVER_URL as URL_HTTPS) ??
      "https://api-k3s.wooting.dev";
    const cdn = REGIONAL_INSTANCE_CONFIG[regionalInstanceId].endpoints.cdn;
    const store =
      (process.env.NEXT_PUBLIC_STORE_URL as URL_HTTPS) ??
      "https://store.wooting.dev";
    return { api, cdn, store };
  }

  return REGIONAL_INSTANCE_CONFIG[regionalInstanceId].endpoints;
}
